import { defineAttrs as e } from "../../utils/typed-attrs.js";
var t = {
	inline: !0,
	group: "inline",
	selectable: !1,
	attrs: e({
		id: { default: "" },
		class: { default: "embercom-prosemirror-composer-marker" }
	}),
	toDOM(e) {
		let t = e.attrs;
		return ["span", {
			id: t.id,
			class: t.class
		}];
	}
};
//#endregion
export { t as markerSpec };
